<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <material-card color="#58595b" title="Customers" offset="0">
          <v-data-table :headers="headers" :items="items" hide-actions>
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                style="color: #4cc7e8"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.name }}</td>
              <td>{{ item.city }}</td>
              <td class="text-xs-right">{{ item.invoices }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      headers: [
        {
          sortable: true,
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "City",
          value: "city",
        },
        {
          sortable: false,
          text: "Total Invoices",
          value: "invoices",
          align: "right",
        },
      ],
      items: [
        {
          name: "Simple Software",
          city: "Cashmere",
          invoices: "$35,738",
        },
        {
          name: "WasteCo",
          city: "St Albans",
          invoices: "$23,738",
        },
        {
          name: "Webmad",
          city: "Christchurch City",
          invoices: "$56,142",
        },
        {
          name: "NCJA Limited",
          city: "Christchurch City",
          invoices: "$38,735",
        },
        {
          name: "Sam Meek Electrical",
          city: "Hornby",
          invoices: "$63,542",
        },
      ],
    }),
  };
</script>
